import { type FC, useContext, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { type ProductOfDayDataType } from '@/common/types/contract';
import { ModalContext } from '@/components/Modals/Modal/config';
import { Close } from '@/components/ui/Close/Close';
import { FullscreenOverlayWrapper } from '@/components/ui/FullscreenOverlayWrapper/FullscreenOverlayWrapper';
import { changeDailyGoodsLinkStatus } from '@/redux/reducers/appReducer';
import { removeFullscreenModal } from '@/redux/reducers/modalsReducer';
import { selectNotUpgradedProductOfDayList } from '@/redux/selectors/contractSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { ProductOfDayOffer } from '../ProductOfDayOffer';

const ProductOfDayOffersModal: FC = () => {
  const { secondModal } = useContext(ModalContext);
  const dispatch = useAppDispatch();
  const contracts = useAppSelector(selectNotUpgradedProductOfDayList);

  useEffect(() => {
    localStorage.setItem(
      'productOfDayOffersLastTimeVisit',
      new Date().toISOString(),
    );
  }, []);

  const closeModal = (): void => {
    localStorage.setItem(
      'daily-goods-upgrade-modal-visit',
      new Date().toISOString(),
    );
    dispatch(changeDailyGoodsLinkStatus(true));
    dispatch(removeFullscreenModal('productOfDayOffers'));
  };

  const openBuyModal = (product: ProductOfDayDataType): void => {
    secondModal.openModal({
      renderKind: 'buyProductOfDayUpgrade',
      props: { product },
    });
  };

  return (
    <FullscreenOverlayWrapper className="flex flex-col items-center justify-between pb-16 720-h:pb-4">
      <Swiper
        className="w-full mt-6 720-h:mt-0"
        centeredSlides={true}
        slidesPerView="auto"
        spaceBetween={16}
      >
        {contracts?.map((contract) => (
          <SwiperSlide
            key={contract.id}
            style={{ width: 'calc(100% - 4rem)' }}
            className="flex justify-center"
          >
            <ProductOfDayOffer
              className="w-full"
              product={contract}
              onBuy={(): void => {
                openBuyModal(contract);
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Close
        onClick={closeModal}
        className="bg-white/10 backdrop-blur-sm"
        variant="modal"
        size="lg"
        imageVariant="modal"
      />
    </FullscreenOverlayWrapper>
  );
};

export { ProductOfDayOffersModal };
